import styled, { css } from 'styled-components'

import { Arrow } from '../../../icons'
import { color, spacing, typography } from '../../../themes'

export const StyledArrow = styled(Arrow)`
  color: ${color('gray.02')};
  height: 16px;
  width: 16px;
  margin: 0 ${spacing(1)};
`

export const Container = styled.li`
  ${typography('caption1')};
  display: flex;
  align-items: center;
`

interface InnerLinkProps {
  active?: boolean
}

export const InnerLink = styled.span<InnerLinkProps>`
  text-decoration: none;
  transition: color 0.2s ease;

  ${({ active }) =>
    active
      ? css`
          color: ${color('link')};

          &:hover {
            color: ${color('blue.03')};
          }
        `
      : css`
          color: ${color('gray.02')};
          pointer-events: none;
        `}
`
